// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { debugLog } from './utils/debugLog';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: new URL(process.env.REACT_APP_PUBLIC_HOSTNAME).hostname,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

// Initialize Analytics
let analytics = null;
if (typeof window !== 'undefined') {
    // Disable analytics when REACT_APP_DISABLE_ANALYTICS is set to 'true'
    if (process.env.REACT_APP_DISABLE_ANALYTICS === 'true') {
        console.log('Firebase Analytics disabled via REACT_APP_DISABLE_ANALYTICS environment variable');
    } else {
        try {
            analytics = getAnalytics(app);
            console.log('Firebase Analytics initialized:', analytics);
        } catch (error) {
            console.error('Failed to initialize Firebase Analytics:', error);
        }
    }
} else {
    console.warn('Window not available, Analytics not initialized');
}

export { analytics };

export default app;

// comment in to use emulator
if (process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === "true") {
    debugLog('using functions emulator')
    const functions = getFunctions(app);
    connectFunctionsEmulator(functions, "localhost", 5001);
}

if (process.env.REACT_APP_USE_AUTH_EMULATOR === "true") {
    debugLog('using auth emulator')
    connectAuthEmulator(auth, "http://localhost:9099")
}

if (process.env.REACT_APP_USE_FIRESTORE_EMULATOR === "true") {
    debugLog('using firestore emulator')
    connectFirestoreEmulator(db, "localhost", 8080);
}

// Note: Firebase Analytics doesn't have an emulator in the web SDK
// Analytics data will be sent to the Firebase project directly